import { NUMBER_STATES } from '../../../core/constants/store';
import { toTicketNumber } from '../utils/numbers';

import '../styles/grid.css';

// Subcomponent surface of the store layout: one page of the 0000–9999 grid.

const STATE_HINT = {
    [NUMBER_STATES.FREE]: 'disponible',
    [NUMBER_STATES.SOLD]: 'ya vendido',
    [NUMBER_STATES.MINE]: 'ya es tuyo',
};

function NumberTile({ value, state, isSelected, onToggle }) {
    const number = toTicketNumber(value);
    const isBuyable = state === NUMBER_STATES.FREE;

    const classes = [
        'number-grid__tile',
        `number-grid__tile--${state}`,
        isSelected ? 'number-grid__tile--selected' : '',
    ].filter(Boolean).join(' ');

    return (
        <button
            type="button"
            className={classes}
            disabled={!isBuyable}
            aria-pressed={isBuyable ? isSelected : undefined}
            aria-label={`Número ${number}, ${STATE_HINT[state]}`}
            onClick={() => onToggle(number)}
        >
            {number}
        </button>
    );
}

export default function NumberGrid({ values, stateOf, isSelected, onToggle }) {
    if (!values.length) {
        return (
            <p className="number-grid__empty">
                No hay números que coincidan con la búsqueda. Prueba con otro prefijo.
            </p>
        );
    }

    return (
        <div className="number-grid">
            {values.map(value => (
                <NumberTile
                    key={value}
                    value={value}
                    state={stateOf(value)}
                    isSelected={isSelected(toTicketNumber(value))}
                    onToggle={onToggle}
                />
            ))}
        </div>
    );
}
